import moment from 'moment';
import store from '@/store/store';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import { getProduitFaceNumerique } from '@/api/panneauxNumeriques';
import { getProduitAssocie, getAllProduitLocations } from '@/api/devis';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import * as devisConf from '@/configuration/devisConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import calculDateFin from '@/services/general/calculDateFin';
import * as produitConf from '@/configuration/produitConf';
import updateQuantiteDispo from '@/services/devisCommandes/updateQuantiteDispo';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import { getAffectionOfProductFace, updateAffection } from '@/services/affectation/affectation';
import { gestionLiaisonsTarifProduitsAssocies } from '@/services/devis/gestionProduitsAssocies';
import generationToutesLignesCommandes from './genererToutesLignesCommande';


async function generationLigneCommandeRegroupement(
  produitFace, produitsAssocies, datePremierAffichage, produit, listIdProduits,
  tauxTvaDefault,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande, tauxTvaDefault);
  nouvelleLigneCommande.quantiteDispo = 1;
  nouvelleLigneCommande.affectation = [];
  nouvelleLigneCommande.logo = null;
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitFace.reference + ' - ' + produitsAssocies.libelle : produitFace.reference;
  nouvelleLigneCommande.produitId = produitFace.id;
  nouvelleLigneCommande.produit = {};
  nouvelleLigneCommande.tauxTva = 0;
  if (produit.periodeCal) {
    nouvelleLigneCommande.dateDebut = produit.periodeCal.debut;
    nouvelleLigneCommande.dateFin = produit.periodeCal.fin;
  } else {
    nouvelleLigneCommande.dateDebut = datePremierAffichage || new Date();
    nouvelleLigneCommande.dateFin = calculDateFin(
      nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
    );
  }
  nouvelleLigneCommande.libelle = produitFace.libelle;
  nouvelleLigneCommande.type = devisConf.REGROUPEMENT;
  nouvelleLigneCommande.typeProduit = produitConf.CATEGORIE_ECRAN_NUMERIQUE;
  nouvelleLigneCommande.masqueLigne = false;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    await gestionLiaisonsTarifProduitsAssocies(
      produitsAssocies, produit, listIdProduits, produitConf.CATEGORIE_ECRAN_NUMERIQUE);
    nouvelleLigneCommande.lignesCommande = generationToutesLignesCommandes(
      produitsAssocies, produit.extensionOpportunite.typeDeRemise, tauxTvaDefault,
    );
  } else nouvelleLigneCommande.lignesCommande = [];
  return nouvelleLigneCommande;
}

export async function getTarification(facesNum, dateDebut) {
  const response = await getProduitFaceNumerique(facesNum.num);
  const produitFace = response.data.result;
  let liaisonTarif = {};
  const typeTarification = planningNumeriqueConf.TYPE_TARIFICATION
    .find(type => type.value === facesNum.extensionOpportunite.typeTarification);
  liaisonTarif = produitFace.liaisonsTarif.find(el =>
    el.produitEnfant.reference === typeTarification.refProduit
    && (moment(el.dateDebut) <= dateDebut
    && (moment(el.dateFin) >= dateDebut || el.dateFin === null)));
  return liaisonTarif;
}

export default async function ajoutLignesCommandeProduitNumerique(
  devisCommande, facesNum, listIdProduits, ordre, tauxTvaDefault,
) {
  const response = await getProduitFaceNumerique(facesNum.num);
  const produitFace = response.data.result;
  let idProduitDefault = produitFace.produitEcranNumerique.produitParDefautId;
  if (idProduitDefault === null) {
    idProduitDefault = listIdProduits.produit;
  }
  let liaisonTarif = {};
  const idSociete = store.getters['user/idSociete'];
  const queryItem = {
    query: {
      numerique: true,
      societeId: idSociete,
    },
    sorting: 'CreationTime DESC',
    maxResultCount: 999999,
  };
  const produitLocNum = (await getAllProduitLocations(queryItem)).data.result.items;
  const typeTarification = planningNumeriqueConf.TYPE_TARIFICATION
    .find(type => type.value === facesNum.extensionOpportunite.typeTarification);
  const produitLoc = produitLocNum.find(el => el.reference === typeTarification.refProduit);
  const produitAssocie = (await getProduitAssocie(produitLoc.id))
    .data.result;
  liaisonTarif = genererLiaisonTarifFromProduitAssocie(
    produitAssocie,
  );
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitFace, liaisonTarif, devisCommande.datePremierAffichage, facesNum, listIdProduits,
    tauxTvaDefault,
  );
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  const affectationList = await getAffectionOfProductFace([nouvelleLignesCommande]);
  if (affectationList[nouvelleLignesCommande.produitId]) {
    await updateAffection(
      nouvelleLignesCommande,
      devisCommande,
      affectationList[nouvelleLignesCommande.produitId],
    );
  }

  updateQuantiteDispo(nouvelleLignesCommande);

  return nouvelleLignesCommande;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduitNumerique.js